<template>
  <div>
    <app-filter :hasFilter="hasFilter" @resetFilters="resetFilters" @changeFilters="changeFilters" :total="total"
                :bigTotal="bigTotal"
                label="Lot" :loading="loading"
                :actions="actionButtons" v-if="!lotFromProgram">
      <div class="columns is-multiline" :class="{'is-border-bottom': !isAdmin}">
        <div class="column is-3 is-border-right is-border-bottom">
          <div class="field">
            <range-chooser :formatter="`{value} ${currency}`"
                           @change="filters.sale_price__gte = $event[0]; filters.sale_price__lte = $event[1]"
                           :max="750000" :label="['Prix min', 'Prix max']"
                           :step="25000" :model="[filters.sale_price__gte, filters.sale_price__lte]"></range-chooser>
          </div>
        </div>
        <div class="column is-3 is-border-right is-border-bottom">
          <div class="field">
            <range-chooser formatter="{value} m2"
                           @change="filters.surface__gte = $event[0]; filters.surface__lte = $event[1]"
                           :max="500" :label="['Surface min', 'Surface max']"
                           :step="25" :model="[filters.surface__gte, filters.surface__lte]">
            </range-chooser>
          </div>
        </div>
        <div class="column is-3 is-border-right is-border-bottom">
          <div class="field">
            <range-chooser :formatter="`{value} ${currency}`" @change="filters.rent__gt = $event[0]; filters.rent__lt = $event[1]"
                           :max="3000" :label="['Loyer HC min', 'Loyer HC max']"
                           :step="50" :model="[filters.rent__gt, filters.rent__lt]"></range-chooser>
          </div>
        </div>
        <div class="column is-3 is-border-right is-border-bottom">
          <div class="field">
            <range-chooser formatter="{value} %"
                           @change="filters.profitability__gt = $event[0]; filters.profitability__lt = $event[1]"
                           :max="30" :step="1" :label="['Rentabilité min', 'Rentabilité max']"
                           :model="[filters.profitability__gt, filters.profitability__lt]"></range-chooser>
          </div>
        </div>
        <div class="column is-3 is-border-right"
             v-if="programs && programs.length && !removeProgramFilter">
          <label class="label">Programme</label>
          <div class="control">
            <multiselect v-model="filters.program" :options="programs" :multiple="false" :searchable="true"
                         class="multiselect--option-ico"
                         value="pk"  :show-labels="false" @select="updateProgramFilter"
                         label="name" track-by="pk" @search-change="getPrograms" :placeholder="''">
              <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez un programme</span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
          </div>
        </div>
        <div class="column is-3 is-border-right">
          <label class="label">{{defaultStateLabel.label | cap}}</label>
          <div class="control">
            <div class="select">
              <select v-model="filters.address__zip_code">
                <option :value="null">Sélectionner {{defaultStateLabel.label}}</option>
                <option v-for='s in states' :value="s.code" :key="s.code">{{s.name}} ({{s.code}})</option>
              </select>
            </div>
          </div>
        </div>

        <div class="column is-3 is-border-right">
          <label class="label">Date de livraison</label>
          <div class="control">
            <div class="select">
              <select v-model="filters.date_livraison">
                <option :value="null">Sélectionner une date de livraison</option>
                <option v-for='trim in trimestrialsChoices' :value="trim[0]">{{trim[1]}}</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="!isAdmin" class="column is-narrow">
          <label class="label">Statut du lot</label>
          <div class="columns is-multiline is-padding-top-small">
            <div class="control column is-narrow is-paddingless" v-for="(s, i) in profilAvailableStatus" :key="i">
              <input class="is-checkradio" :id="s.value" type="checkbox" :name="s.value" :value="s.value"
                     v-model="filters.status">
              <label :for="s.value">{{ s.label }}</label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isDistributeurMode && isAdmin" class="columns is-border-bottom is-border-top">
        <div class="column is-3 is-border-right">
          <div class="field">
            <label class="label">Promoteur</label>
            <div class="control">
              <multiselect @select="updatePromoteurFilter" v-model="filters.promoteur" label="name" track-by="name"
                           :options="promoteurs" :searchable="true"  :show-labels="false"
                           class="multiselect--option-ico"
                           @search-change="getPromoteurs" :placeholder="''">
                <template slot="clear" slot-scope="props">
                  <div class="multiselect__clear" v-if="promoteurs.length"
                       @mousedown.prevent.stop="clearAll(props.search)"></div>
                </template>
                <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez un promoteur</span>
                <span slot="noOptions">La liste est vide</span>
              </multiselect>
            </div>
          </div>
        </div>
        <div class="column is-3 is-border-right">
          <label class="label">Provenant de flux promoteur</label>
          <div class="control">
            <div class="select">
              <select v-model="filters.from_flux">
                <option :value="null">Flux promoteur</option>
                <option :value="0">Non</option>
                <option :value="1">Oui</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-one-third is-border-bottom is-border-right">
          <p class="label">Nombre de {{lotDefaultTypeLabel}}</p>
          <div class="columns is-multiline is-padding-top-small">
            <div class="control column is-narrow is-paddingless" v-for="(t, i) in typesFilterList" :key="i">
              <input class="is-checkradio" :id="t.value" type="checkbox" :name="t.value" :value="t.value"
                     v-model="filters.lot_type">
              <label :for="t.value">{{ t.label }}</label>
            </div>
          </div>
        </div>
        <div class="column is-border-bottom">
          <p class="label">Nature du bien</p>
          <div class="columns is-multiline is-padding-top-small">
            <div class="control column is-narrow is-paddingless" v-for="(n, i) in naturesList" :key="i">
              <input class="is-checkradio" :id="n.value" type="checkbox" :name="n.value" :value="n.value"
                     v-model="filters.nature">
              <label :for="n.value">{{ n.label }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div v-if="isAdmin" class="column is-narrow is-border-bottom is-border-right">
          <label class="label">Statut du lot</label>
          <div class="columns is-multiline is-padding-top-small">
            <div class="control column is-narrow is-paddingless" v-for="(s, i) in profilAvailableStatus" :key="i">
              <input class="is-checkradio" :id="s.value" type="checkbox" :name="s.value" :value="s.value"
                     v-model="filters.status">
              <label :for="s.value">{{ s.label }}</label>
            </div>
          </div>
        </div>

      </div>

    </app-filter>
    <div class="column has-bg-light is-border-bottom is-paddingless-top is-paddingless-bottom">
      <pagination :loading="loading" @ChangePage="currentPage = $event" :currentPage="currentPage"
                  :totalPage="totalPage"></pagination>
    </div>
    <div class="">
      <table v-show="!loading && items.length"
             class="table is-fullwidth is-last-fixed-small is-first-fixed-medium">
        <thead>
        <tr class="is-size-6">
          <th>
            <sortable @sort="sort('status', $event)" :sort="sortBy.status" label="Statut"></sortable>
          </th>
          <th class="col-ref">
            <sortable @sort="sort('ref', $event)" :sort="sortBy.ref" label="Lot"></sortable>
          </th>
          <th v-if="showColumn('program_name') && !lotFromProgram">
            <sortable @sort="sort('program_name', $event)" :sort="sortBy.program_name" label="Programme"></sortable>
          </th>
          <th v-if="isDistributeurMode && showColumn('promoteur_name') && !lotFromProgram && isAdmin">
            <sortable @sort="sort('promoteur_name', $event)" :sort="sortBy.promoteur_name" label="Promoteur"></sortable>
          </th>
          <th v-if="showColumn('sale_price')">
            <sortable @sort="sort('sale_price', $event)" :sort="sortBy.sale_price" label="Prix de Vente"></sortable>
          </th>
          <th v-if="showColumn('tax_dispositifs')">
            <sortable @sort="sort('tax_dispositifs', $event)" :sort="sortBy.tax_dispositifs"
                      label="Dispositif"></sortable>
          </th>
          <th v-if="showColumn('surface')">
            <sortable @sort="sort('surface', $event)" :sort="sortBy.surface" label="Surface"></sortable>
          </th>
          <th v-if="showColumn('nature')">
            <sortable @sort="sort('nature', $event)" :sort="sortBy.nature" label="Nature"></sortable>
          </th>
          <th v-if="showColumn('lot_type')">
            <sortable @sort="sort('lot_type', $event)" :sort="sortBy.lot_type" label="Type"></sortable>
          </th>
          <th v-if="showColumn('profitability') && !lotFromProgram">
            <sortable @sort="sort('profitability', $event)" :sort="sortBy.profitability"
                      label="Rentabilité">
            </sortable>
          </th>
          <th v-if="showColumn('rent')">
            <sortable @sort="sort('rent', $event)" :sort="sortBy.rent" label="Loyer HC"></sortable>
          </th>
          <th v-if="showColumn('floor')">
            <sortable @sort="sort('floor', $event)" :sort="sortBy.floor" label="Étage"></sortable>
          </th>
          <th v-if="showColumn('exposures') && !lotFromProgram">
            <sortable @sort="sort('exposures', $event)" :sort="sortBy.exposures" label="Orientation"></sortable>
          </th>
          <th class="has-text-centered">
            <div class="dropdown is-hoverable is-right">
              <div class="dropdown-trigger">
                <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                  <i class="fal fa-cog"></i>
                </button>
              </div>
              <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="lot in items" :key="lot.pk" class="is-size-6"
            :class="{'tr--draft': lot.status === 'draft'}">
          <!-- <td>{{lot.status | statusLabel}}</td> -->
          <!--<td class="has-text-centered"><span class="dot" :class="lot.status | dotClass"></span></td>-->
          <td>
            <span class="tag" :class="tagColor(lot.status)">{{lot.status | statusLabel}}</span>
          </td>
          <router-link  tag="td" :to="{name: 'LotVue', params: {id: lot.pk}}" class="is-cell-hoverable">
            <a class="fullLink">
              <span class="">{{lot.ref || '-'}}</span>
            </a>
          </router-link>
          <td v-if="showColumn('program_name') && !lotFromProgram" class="is-cell-hoverable">
            <router-link :to="{name:'ProgramVue', params: {id: lot.program}}">
              {{lot.program_name | truncate}}
            </router-link>
            <span class="icon has-text-grey tooltip is-tooltip-right is-padding-left-xsmall is-size-5"
                data-tooltip="Flux promoteur" v-if="isDistributeurMode && program.from_flux && !isExternal">
              <i class="fas fa-rss"></i>
            </span>
          </td>
          <td v-if="isDistributeurMode && showColumn('promoteur_name') && !lotFromProgram && isAdmin"
              class="is-cell-hoverable">
            <router-link :to="{name:'PromoteurVue', params: {id: lot.promoteur}}">
              {{lot.promoteur_name | truncate}}
            </router-link>
          </td>
          <td v-if="showColumn('sale_price')"><span v-if="lot.sale_price">{{lot.sale_price | prettyPrice}} {{$currency}}</span><span
            v-else>-</span></td>
          <td v-if="showColumn('tax_dispositifs')">
            <span v-if="lot.tax_dispositifs && lot.tax_dispositifs.length > 0">
              {{lot.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData)}}
            </span>
            <span v-else>-</span>
          </td>
          <td v-if="showColumn('surface')"><span v-if="lot.surface">{{lot.surface}} m²</span><span v-else>-</span></td>
          <td v-if="showColumn('lot_type')">{{lotTypeLabel(lot.lot_type)}}</td>
          <td v-if="showColumn('nature')">{{natureLabel(lot.nature)}}</td>
          <td v-if="showColumn('profitability') && !lotFromProgram"><span v-if="lot.profitability">{{lot.profitability | prettyPrice}} %</span><span
            v-else>-</span></td>
          <td v-if="showColumn('rent')"><span v-if="lot.rent">{{lot.rent | prettyPrice}} {{$currency}}</span><span v-else>-</span>
          </td>
          <td v-if="showColumn('floor')"><span v-if="lot.floor">{{lot.floor}}</span><span v-else>-</span></td>
          <td v-if="showColumn('exposures') && !lotFromProgram"><span v-if="lot.exposures">{{lot.exposures | exposuresLabel}}</span><span
            v-else>-</span></td>
          <td class="has-text-centered actions">
            <div v-if="isManager || isSeller">
              <button class="button is-circle is-small" @click.prevent.stop="addToWishlist(lot.pk)"
                      v-if="!isWishlisted(lot)">
                <i class="fal fa-star"></i>
              </button>
              <button class="button is-circle is-small" @click.prevent.stop="deleteFromWishlist(lot.pk)" v-else>
                <i class="fas fa-star"></i>
              </button>
            </div>
            <display-button-list v-else-if="lotFromProgram"
                                 :forceDropDown="true" :data="lot"
                                 @hover="buttonListHover(lot)" :buttons="buttonList">
            </display-button-list>
            <display-button-list v-else
                                 :forceDropDown="true" :data="lot"
                                 @hover="buttonListHover(lot)" :buttons="buttonList"
                                 :is-checked="checkedItem(lot.pk)" :check-available="checkAvailable"
                                 :multiselection="multiselection" @selected="selectItem">
            </display-button-list>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-show="!loading && !items.length">
      <div class="columns">
        <div class="column">
          <h2 class="title is-3 has-text-weight-bold">Aucun lot disponible</h2>
          <a class="has-text-primary" @click="resetFilters" v-if="hasFilter && !lotFromProgram"><span
            class="icon is-small"><i
            class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="column has-bg-light is-border-bottom is-paddingless-top is-paddingless-bottom">
      <pagination :loading="loading" @ChangePage="currentPage = $event" :currentPage="currentPage"
                  :totalPage="totalPage"></pagination>
    </div>
  </div>
</template>

<script>
  import {
    GenericList,
    Sort,
    Filter,
    DefaultValues,
    OptionStatus,
    ColumnConf,
    DownloadFile,
    MultiSelection
  } from '../../mixins'
  import { mapState, mapGetters } from 'vuex'
  import { exportXls } from '../../utils'

  export default {
    name: 'LotList',
    mixins: [GenericList, Sort, Filter, DefaultValues, OptionStatus, ColumnConf, DownloadFile, MultiSelection],
    filters: {
      prettyTaxDispositifs (values, data) {
        return values.map((x, i) => {
          if (i < 2) {
            return data[x].short_label || data[x].label
          }
        }).join(', ')
      },
      dotClass (value) {
        const COLORS = {
          'available': 'is-disponible',
          'optioned': 'is-optionne',
          'sold': 'is-acte',
          'draft': 'is-draft',
          'reserved': 'is-reserve'
        }
        return COLORS[value]
      }
    },
    props: {
      lotFromProgram: {
        type: Object
      }
    },
    computed: {
      ...mapState({
        runningOptions: 'runningOptions',
        wishlists: 'wishlists',
        states: 'states',
        promoteursList: 'promoteurs'
      }),
      ...mapGetters([
        'currentUserPk', 'isAdmin', 'currentUserProfil',
        'isManager', 'isSeller', 'isExternal', 'isOperator',
        'isEditor', 'isDistributeurMode'
      ]),
      profilAvailableStatus () {
        let status = []
        status.push(this.statusData.available)
        status.push(this.statusData.optioned)
        if (this.isAdmin) {
          status.push(this.statusData.draft)
          status.push(this.statusData.sold)
          status.push(this.statusData.reserved)
        }
        return status
      },
      currency () {
        return this.$currency
      },
      programFromFlux () {
        if (this.lotFromProgram) {
          return this.lotFromProgram.from_flux
        }
      },
      columnsShow () {
        const columns = {
          sale_price: {
            label: 'Prix',
            mobile: true
          },
          surface: {
            label: 'Surface',
            mobile: true
          },
          lot_type: {
            label: 'Type',
            mobile: true
          },
          nature: {
            label: 'Nature',
            mobile: true
          },
          rent: {
            label: 'Loyer',
            mobile: true
          },
          floor: {
            label: 'Étage',
            mobile: true
          },
          tax_dispositifs: {
            label: 'Dispositifs',
            mobile: false
          }
        }
        if (!this.lotFromProgram) {
          columns.program_name = {
            label: 'Programme',
            mobile: true
          }
          columns.profitability = {
            label: 'Rentabilité',
            mobile: true
          }
          columns.exposures = {
            label: 'Orientation',
            mobile: true
          }
          if (this.isAdmin && this.isDistributeurMode) {
            columns.promoteur_name = {
              label: 'Promoteur',
              mobile: true
            }
          }
        }
        return columns
      }
    },
    data () {
      return {
        enableSaveQuery: true,
        columnsConfResource: 'lot',
        actionButtons: [
          {
            linkClass: ['button', 'is-white'],
            icon: ['fas', 'fa-check'],
            display: () => {
              return !this.multiselection && this.isAdmin
            },
            action: () => {
              this.multiselection = !this.multiselection
            },
            text: 'Sélection multiple'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['fal', 'fa-ban'],
            display: () => {
              return this.multiselection
            },
            action: () => {
              this.multiselection = !this.multiselection
              this.clearSelectedItems()
            },
            text: 'Annuler'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['far', 'fa-exchange-alt'],
            display: () => {
              return this.multiselection && this.selectedItems.length
            },
            action: () => {
              this.changeStatusSelection()
            },
            text: 'Changer statut de la sélection'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['far', 'fa-file-excel'],
            display: () => {
              return this.isAdmin && !this.multiselection
            },
            action: () => {
              exportXls('lots-export', this.query)
            },
            text: 'Export .xls'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['fa-sync'],
            action: () => {
              this.loadItems()
            }
          }
        ],
        buttonList: [
          {
            routeName: 'LotVue',
            icon: 'fa-eye',
            text: 'Voir'
          },
          {
            icon: 'fa-download',
            text: 'Télécharger le plan',
            action: (id) => {
              let selectedLot = this.items.find(x => x.pk === id)
              this.downloadFile(selectedLot.documents, selectedLot.ref, '.zip')
            },
            display: (lot) => {
              return lot.documents && lot.documents.length
            }
          },
          {
            icon: 'fa-flag',
            text: 'Poser une option',
            action: (id) => {
              this.selectedLot = id
              this.$router.push({name: 'OptionCreate', query: {lot: id}})
            },
            display: (lot) => {
              if (this.isOperator || this.isEditor) {
                return false
              }
              const option = this.runningOptions.find(o => o.lot === lot.pk)
              if (option && option.seller === this.currentUserPk && option.status === 'pending') {
                return false
              }
              const program = this.lotInfoPrograms.find(p => p.pk === lot.program)
              return program && this.canBeOptioned(lot.status, program)
            }
          },
          {
            icon: 'fa-star',
            text: 'Ajouter aux favoris',
            action: (id) => {
              this.selectedLot = id
              this.addToWishlist(this.selectedLot)
            },
            display: (lot) => {
              return !this.wishlists.find(w => w.lot === lot.pk)
            }
          },
          {
            icon: 'fas fa-star',
            text: 'Supprimer des favoris',
            action: (id) => {
              this.selectedLot = id
              this.deleteFromWishlist(this.selectedLot)
            },
            display: (lot) => {
              return this.wishlists.find(w => w.lot === lot.pk)
            }
          },
          {
            routeName: 'LotEdit',
            icon: 'fa-edit',
            text: 'Editer',
            needProfile: ['admin', 'editor']
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fa-trash',
            text: 'Supprimer',
            needProfile: ['admin']
          }
        ],
        lotInfoPrograms: [],
        programs: [],
        promoteurs: [],
        loadDocuments: this.loadItems,
        service: this.$api.lotService,
        removeProgramFilter: false,
        contacts: [],
        selectedLot: null,
        filters: {
          status: ['available', 'optioned'],
          nature: [],
          lot_type: []
        },
        initFilters: {
          status: ['available', 'optioned'],
          nature: [],
          lot_type: []
        },
        myOptions: [],
        statusInputOptions: {
          'available': 'Disponible',
          'draft': 'Brouillon'
        },
        checkAvailable: {
          key: 'status',
          values: ['available', 'draft']
        }
      }
    },
    watch: {
      'filters.promoteur' (v) {
        this.updatePromoteurFilter(v)
      },
      'filters.program' (v) {
        this.updateProgramFilter(v)
      }
    },
    methods: {
      tagColor (value) {
        const COLORS = {
          'available': 'is-disponible',
          'optioned': 'is-optionne',
          'sold': 'is-acte',
          'draft': 'is-draft',
          'archived': 'is-draft',
          'reserved': 'is-reserve'
        }
        return COLORS[value]
      },
      buttonListHover (lot) {
        const lotInList = this.lotInfoPrograms.find(p => {
          return p.pk === lot.program
        })
        if (!lotInList) {
          this.$api.programService.getOne(lot.program).then(r => {
            this.lotInfoPrograms.push(r.data)
            this.$set(this, 'items', this.items)
          })
        }
      },
      canBeOptioned (lotStatus, program) {
        if (lotStatus && program) {
          const verifyOptions = this.myOptions.filter(x => x.pk === this.lot.pk)
          const okStatus = ['available', 'optioned']
          const programOkStatus = ['available', 'private']
          return programOkStatus.includes(program.status) && program.is_optionable && okStatus.includes(lotStatus) && !verifyOptions.length
        }
      },
      getMyOptions () {
        this.$api.optionService.get(this.currentUserPk).then(res => {
          this.myOptions = res.data
        }).catch(err => {
          console.log(err)
        })
      },
      updateProgramFilter (e) {
        this.$set(this.filters, 'program', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updatePromoteurFilter (e) {
        this.$set(this.filters, 'promoteur', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      beforeGet () {
        if (this.query.program && typeof this.query.program === 'object') {
          this.query.program = this.query.program.pk
        }
        if (this.query.promoteur && typeof this.query.promoteur === 'object') {
          this.query.promoteur = this.query.promoteur.pk
        }
        if (Array.isArray(this.query.lot_type)) {
          const tmp = []
          this.query.lot_type.forEach(t => {
            tmp.push(t)
            tmp.push(t + '_duplex')
            tmp.push(t + '_bis')
          })
          this.query.lot_type = tmp
        }
        this.$emit('loading', true)
      },
      getPrograms (query = null) {
        this.$api.programService.get({name: query}).then(r => {
          this.programs = r.data.items
        })
      },
      getPromoteurs (query) {
        this.$api.promoteurService.get({name: query}).then(r => {
          this.promoteurs = r.data.items
        })
      },
      addToWishlist (id) {
        this.$api.lotService.postWishlist({lot: id}).then(r => {
          this.$store.commit('addWishlist', {wishlist: r.data})
          this.$notify({
            type: 'is-success',
            text: 'Ajouté aux favoris.'
          })
        })
      },
      deleteFromWishlist (id) {
        let wishlist = this.wishlists.find(w => w.lot === id)
        this.$api.lotService.deleteWishlist(wishlist.pk).then(r => {
          this.$store.commit('removeWishlist', {wishlistPk: wishlist.pk})
          this.$notify({
            type: 'is-success',
            text: 'Supprimé de la liste des favoris'
          })
        })
      },
      isWishlisted (lot) {
        return this.wishlists.find(w => w.lot === lot.pk)
      },
      afterSuccessGet (r) {
        this.$emit('loading', false)
      }
    },
    created () {
      if (this.lotFromProgram) {
        this.$set(this.filters, 'program', this.lotFromProgram.pk)
        this.$set(this, 'enableSaveQuery', false)
        if (this.isAdmin) {
          this.$set(this.filters, 'status', ['available', 'optioned', 'draft'])
        }
      } else if (this.isDistributeurMode) {
        this.promoteurs = this.promoteursList.slice()
      }

      if (!this.$route.query.program && !this.lotFromProgram) {
        this.getPrograms()
      }
      Object.assign(this.filters, this.$route.query)
      this.changeFilters()
    }
  }
</script>

<style>
  .col-ref {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/lot/LotList.vue